import { IconButton, Text } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import i18next from "i18next";

import { isAdmin } from "../../authConfig";
import styles from "./Answer.module.css";

interface ReasoningSummaryProps {
    reasoningSummary?: string | null;
}

export const ReasoningSummary: React.FC<ReasoningSummaryProps> = ({ reasoningSummary }) => {
    const [isExpanded, { toggle: toggleExpanded }] = useBoolean(false);

    if (!isAdmin || !reasoningSummary) {
        return null;
    }

    return (
        <div className={styles.reasoningSummaryContainer}>
            <div className={styles.reasoningSummaryHeader} onClick={toggleExpanded}>
                <IconButton
                    iconProps={{ iconName: isExpanded ? "ChevronUp" : "ChevronDown" }}
                    className={styles.reasoningSummaryToggle}
                    ariaLabel="Toggle reasoning summary"
                />
                <Text className={styles.reasoningSummaryLabel}>{i18next.t("answer.reasoningSummary")}</Text>
            </div>
            {isExpanded && (
                <div className={styles.reasoningSummaryContent}>
                    <Text>{reasoningSummary}</Text>
                </div>
            )}
        </div>
    );
};
